import { render, staticRenderFns } from "./GpListItem.vue?vue&type=template&id=280e76d5&scoped=true&"
import script from "./GpListItem.vue?vue&type=script&lang=js&"
export * from "./GpListItem.vue?vue&type=script&lang=js&"
import style0 from "./GpListItem.vue?vue&type=style&index=0&id=280e76d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280e76d5",
  null
  
)

export default component.exports